import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-adminap-view',
  templateUrl: './adminap-view.component.html',
  styleUrls: ['./adminap.component.css']
})
export class AdminapviewComponent implements OnInit {

  ViewCustomer: any = [];
  actionHistory: any = [];
  listservices: any = [];
  liststb: any = [];
  liststbcust: any = [];
  listfactoryreset: any = [];
  alert_act='';
  reasonapproval : any;

  alert_failed = false
  alert_success = false
  customerid : string;

  formReset = this.fb.group({
    approvalstatus: [''],
    note: [''],
  })

  constructor(
	  private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJsOrder: LoadJsService,
	  private router: Router,
	  public partnerService: ApiPartnerService
  ) { }

  ngOnInit() {
  	this.loadStart();

  }
  
  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');
  	//alert(id);
    this.customerid = id;
    this.loadCustomer(id)
    this.loadDetailreason(id)
  }

  loadCustomer(id: any) {
    return this.partnerService.GetViewCustomer(id).subscribe((output: any) => {
    console.log(output);
       this.ViewCustomer = output.data;
       this.listservices = output.data.services;
       this.liststb = output.data.stb;
       this.liststbcust = output.data.stbcust;
       this.actionHistory = output.data.actionHistory;
    })
  }

  

  

  loadDetailreason(id: any) {
    return this.partnerService.Getapprovalreason(id).subscribe((output: any) => {
    console.log(output);
       this.reasonapproval = output.data;
    })
  }

  loadDetailreset(id: any) {
    return this.partnerService.GetListcustfactoryreset(id).subscribe((output: any) => {
    console.log(output);
       this.listfactoryreset = output.data;
    })
  }

  onActionClick(act:any, item: any)
  {
    this.alert_act = act;
    console.log(act);
    this.formReset.reset()

    // if ( act == "setkondisi" || act == "approve") {
    //   this.formApprove.reset()
    //   this.itemstb = item
    // }
  }

  submitreset(item:any, el: HTMLElement) {
    this.partnerService.PostCustfactoryreset(item.id, this.formReset.value)
      .subscribe((output: any) => {
        console.log(output)
        if ( output.status ){
          this.loadStart()
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
  
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
          setTimeout(()=>{
            this.alert_success = false
          }, 6000);
          
        } else {
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
      }
    )
  }

  submitagree(item:any, el: HTMLElement) {
    console.log(item);
    this.formReset.get('approvalstatus').setValue(1);
    console.log(this.formReset.value)
    this.partnerService.PostApprovalagree(item.id, this.formReset.value)
      .subscribe((output: any) => {
        console.log(output);
        if ( output.status ){
         alert('Sukses di approve, Tagihan sudah disubmit ');
         this.ViewCustomer.customersts = 100;
         this.reasonapproval.notes = output.data.note;
         this.ViewCustomer.customerstatusname =  output.data.customerstatusname;
        } else {
          alert('gagal');
        }
      }
    )
  }

  submitreject(item:any, el: HTMLElement) {
    console.log(item);
    this.formReset.get('approvalstatus').setValue(2);
    
    this.partnerService.PostApprovalagree(item.id, this.formReset.value)
      .subscribe((output: any) => {
        console.log(output);
        if ( output.status ){
          alert('Sukses di tolak, SN sudah kembali idle ');
          this.ViewCustomer.customersts = 110;
          this.ViewCustomer.customerstatusname =  output.data.customerstatusname;
          this.reasonapproval.notes = output.data.note;
          //this.loadDetailreason(this.customerid);
        } else {
          alert('gagal');
        }
      }
    )
  }

  getReason(key)
  {
    if ( this.reasonapproval == undefined){
      return false;
    }else if ( this.reasonapproval[key] != undefined){
      return this.reasonapproval[key];
    }
  }

}

